<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size md_size">
            <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ $t('TITLE.APPROVAL.POPUP.TITLE') }}</i>
                </dt>
                <dd>

                    <table class="create_table mt-20">
                        <colgroup>
                            <col width="154px">
                            <col class="*">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    {{ $t('FIELD.GLOBAL.SUBJECT') }}
                                    <!-- <em class="txt_mandatory">*</em> -->
                                </th>
                                <td>
                                    {{ detail.KNOWLEDGE_TITLE }}
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.SURVEY.FROM') }}</th>
                                <td>
                                    <span class="mr10">{{ detail.REQ_USER_NM }}</span>      <!-- 컨텐츠 최종 수정자 이름 -->
                                    <span class="mr10">{{ detail.REQ_USER_CORP_NM }}</span> <!-- 컨텐츠 최종 수정자 법인명 -->
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.GLOBAL.DATE') }}</th>
                                <td>
                                    {{ detail.REQ_DT }}
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('FIELD.GLOBAL.OPINION') }}</th>
                                <td v-html="getDescription"></td>
                            </tr>
                        </tbody>
                    </table>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_modal_wrap topLine mt-0">
                        <div class="btn_right">
                            <a href="javascript:" class="btn_white" :title="$t('BUTTON.GLOBAL.DELETE.TODO.LIST')" @click="btnDelete">{{ $t('BUTTON.GLOBAL.DELETE.TODO.LIST') }}</a>
                            <a href="javascript:" class="btn_blue" :title="$t('BUTTON.GLOBAL.GO.TO.MODIFY')" @click="btnModify">
                                {{ $t('BUTTON.GLOBAL.GO.TO.MODIFY') }}
                                <em class="ico_infoW_btn">
                                    <i class="tooltip fl_right">
                                        {{ $t('MESSAGE.REQUEST.SHARING.MODIFY.TOOLTIP') }}
                                    </i>
                                </em>
                            </a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue                                  from 'vue';
import { mapGetters }                       from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import axios                                from 'axios';
import qs                                   from 'query-string';

import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

const fetchDetail = (knowledgeId, shareId) => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/getKnowledgeReqShareDetail.skp`,
    qs.stringify({ KNOWLEDGE_ID: knowledgeId, SHARE_ID: shareId }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'RequestSharingFromPopup',
    props: {
        knowledgeId:    { required: true },
        shareId:        { required: true },
        rtnFunc:        { type: Function }
    },
    data() {
        return {
            detail: {},
            requesterId: ''
        }
    },
    computed: {
        getDescription: function() {
            if(!SDLUtil.isNull(this.detail.APRV_OPINION)) {
                return this.detail.APRV_OPINION.replace(/(?:\r\n|\r|\n)/g, '<br />');

            } else {
                return "";
            }
        }
    },
    methods: {
        initLoad() {
            SDLUtil.showLoadingBar(true);
            return fetchDetail(this.knowledgeId, this.shareId)
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        btnDelete() {
            let that = this,
                msgDelete = SDLUtil.getMsgProp('FIELD.GLOBAL.DELETE'),
                params = { KNOWLEDGE_ID: this.knowledgeId, SHARE_ID: this.shareId };

            SDLUtil.confirm({
                title: 'FIELD.GLOBAL.DELETE',
                msg: SDLUtil.getMsgProp('MESSAGE.CONFIRM.OPERATION', [msgDelete]),
                onOkEvt: () => {
                    return  axios.post(
                                `${SDLUtil.API_URL}/basis/myKnowledge/serviceScript/refuseRequestSharing.skp`,
                                qs.stringify(params),
                                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                            )
                            .then(res => {
                                let data = res.data;
                                if(data.msg) {
                                    SDLUtil.alert({
                                        title: 'MESSAGE.DATA.DELETED',
                                        msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                                        onOkEvt: () => {
                                            that.rtnFunc(true);
                                            that.$emit('close');
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                SDLUtil.errorAlert(err);
                            });
                }
            });
        },
        btnModify() {
            let that = this,
                msgModify = SDLUtil.getMsgProp('BUTTON.GLOBAL.MODIFY')

            SDLUtil.confirm({
                title: 'BUTTON.GLOBAL.MODIFY',
                msg: SDLUtil.getMsgProp('MESSAGE.CONFIRM.OPERATION', [msgModify]),
                onOkEvt: () => {
                    store.commit('POPUP_PARAMS', {
                        knowledgeId: that.knowledgeId,
                        shareId: that.shareId,
                        isModify: true,
                        isRequestSharing: true,
                        requesterId: that.requesterId
                    });

                    let linkUrl = MenuUtil.getRedirectUrl('/basis/myKnowledge/myKnowledge/register/registerForm');
                    const detailPop = SDLUtil.openLegacyWindowPopup({
                        url: linkUrl,
                        title: SDLUtil.getMsgProp('TITLE.KNOWLEDGE.DETAIL'),
                        w: 1366,
                        h: 768
                    });

                    let popTimer = window.setInterval(function() {
                        if (detailPop.closed !== false) { // !== is required for compatibility with Opera
                            window.clearInterval(popTimer);
                            that.rtnFunc(true);
                            that.$emit('close');
                        }
                    }, 200);
                }
            });
        },
        btnClose() {
            this.$emit('close');
        }
    },
    created() {
        this.initLoad().then( data => {
            if(data.success) {
                if(data.detail.rowCount > 0) {
                    this.detail = data.detail.rowData[0];
                    this.requesterId = this.detail.REQ_USER_NO;
                    SDLUtil.showLoadingBar(false);

                } else {
                    SDLUtil.alert({
                        msg: 'MESSAGE.GLOBAL.NO.DATA',
                        onOkEvt: () => {
                            this.btnClose();
                        }
                    });
                }

            } else {
                SDLUtil.alert({
                    title: 'TITLE.WARNING.TITLE',
                    msg: 'MESSAGE.AUTH.NOAUTH',
                    onOkEvt: () => {
                        this.btnClose();
                    }
                });
            }

            SDLUtil.showLoadingBar(false);
        });
    },
    mounted() {

    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/common/RequestSharingFromPopup.vue